import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { PendingStateUpdate } from './pending-state-update';
export { PendingStateUpdate };
import { pendingStateUpdateSchema } from '@schemas/business-objects/pending-state-update';
import { ProcessInstanceFormGroup } from './process-instance-form-group';

export class PendingStateUpdateFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    triggerId: SchemaFormControl;
    timestamp: SchemaFormControl;
    processInstanceId: SchemaFormControl;
    processInstance: ProcessInstanceFormGroup;
  };

  declare value: Partial<PendingStateUpdate>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(pendingStateUpdateSchema, PendingStateUpdate, data, options);
  }

  get object(): PendingStateUpdate {
    return new PendingStateUpdate(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processInstance':
        return new ProcessInstanceFormGroup();
      default:
        return undefined;
    }
  }
}

export class PendingStateUpdateFormArray extends PersistedFormArray {
  readonly entityName = 'PendingStateUpdate' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(pendingStateUpdateSchema, PendingStateUpdate, options);
  }

  protected override createItemGroup() {
    return new PendingStateUpdateFormGroup();
  }

  get array(): PendingStateUpdate[] {
    return this.controls.map(
      (group: PendingStateUpdateFormGroup) => group.object,
    );
  }
}

export class PendingStateUpdatePersistedArray extends PersistedArray<PendingStateUpdate> {
  readonly entityName = 'PendingStateUpdate' as const;

  constructor(options?: PersistedArrayOptions) {
    super(PendingStateUpdate, options);
  }
}
